<template>
  <div class="">
    <div>
      <div class="row">
        <div class="col-12">
          <vs-table :data="templates" :max-items="30" stripe search pagination>

            <div slot="header" class="flex-grow justify-left mb-4">
              <h3 class="mt-4 mb-2">Lista de plantillas</h3>
              <vs-button size="small" @click="isFormPrompt = true" icon="add_circle_outline" color='success'>Nueva
                plantilla</vs-button>
            </div>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Molde Id</vs-th>
              <vs-th>Nombre</vs-th>
              <vs-th>Descripción</vs-th>
              <vs-th>Fecha de creación</vs-th>
              <vs-th>Acciones</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(template, index) in data" :key="index">
                <vs-td>{{ template.id }}</vs-td>
                <vs-td>{{ template.mold_id }}</vs-td>
                <vs-td><vs-button @click.stop="loadPreviewTemplate(template.id)" size='small'>
                    {{ template.name }}
                  </vs-button>
                </vs-td>
                <vs-td>{{ template.description }}</vs-td>
                <vs-td>{{ template.created_at | humanize }}</vs-td>
                <vs-td>
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    class="ml-6" @click.stop="isFormPromptEdit = true, templateIdSelected=template.id" />

                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    class="ml-6" @click.stop="_delete(`${template.id}`)" />
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </div>

    </div>

    <vs-popup :active.sync="modal.show" :title="modal.title">
      <div v-html="modal.content.body"></div>
      <div class="mt-6">
        <vs-button color="dark" @click="closeModal">Cerrar</vs-button>
      </div>
    </vs-popup>

    <!-- FORM  NEW -->
    <vs-popup v-if="isFormPrompt" id="form-template" fullscreen :active.sync="isFormPrompt" :title="modal.title">
      <Form @updated="getTemplates"></Form>
    </vs-popup>

    <!-- FORM  Edit -->
    <vs-popup v-if="isFormPromptEdit" id="form-template" fullscreen :active.sync="isFormPromptEdit" :title="modal.title">
      <Edit 
        :templateId="templateIdSelected"
        @updated="getTemplates"></Edit>
    </vs-popup>

  </div>
</template>

<script>
import {
  _humanizeDate,
  fromNowDate
} from "@/filters/momentTzConvert";
import syntaxHighlight from "@mixins/syntaxHighlightJSON";
import Form from "./Form.vue";
import Edit from "./Edit.vue";

export default {
  name: "Campaigns",
  mixins: [syntaxHighlight],
  components: {
    Form,
    Edit
  },
  data: () => ({
    templates: [],
    modal: {
      show: false,
      title: 'Template preview: #',
      content: '',
    },
    isFormPrompt: false,
    isFormPromptEdit: false,
    templateIdSelected: null
  }),
  async mounted() {
    this.startLoading();
    await axios.get(`/api/app-http-services/services/notifications/email/templates`)
      .then(response => this.templates = response.data);
    this.stopLoading();
  },
  filters: {
    humanize: _humanizeDate,
    ago: fromNowDate
  },
  methods: {
    async getTemplates() {
      try {
        const res = await axios.get(`/api/app-http-services/services/notifications/email/templates`)
        this.templates = res.data;
        this.isFormPrompt = false;
        this.isFormPromptEdit = false;
        this.templateIdSelected = null;
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.modal.show = false;
    },
    async _delete(template_id) {
      swal({
        title: `¿Esta seguro de eliminar el template #${template_id}?`,
        text: "* Esta acción no se puede revertir",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
        .then(async (willDelete) => {
          if (willDelete) {
            this.startLoading();
            try {
              await axios.delete(
                `/api/app-http-services/services/notifications/email/templates/${template_id}`);
              location.reload();
            } catch (e) {
              if (e.response.status === 422) {
                await swal("Alerta", JSON.stringify(e.response.data), 'warning');
              }
              if (e.response.status === 500) {
                await swal("Error", "Hubo un error no controlado en el servicio de templates", 'error');
              }
            } finally {
              this.stopLoading();
            }
          } else {
            swal("¡Acción cancelada!");
          }
        });
    },
    // async loadPreviewTemplate(email_template_id) {
    //   let template = this.templates[this.templates.map(c => c.id).indexOf(email_template_id)];
    //   this.modal.title = `${template.name} #${template.id}`;
    //   this.modal.content = template.content;
    //   this.modal.show = true;
    //   console.log(template);
    // },
    async loadPreviewTemplate(email_marketing_template_id) {
      const url = `${this.ApiDomain}/api/app-http-services/get/blades/templates/${email_marketing_template_id}?access_token=${this.AccessToken}`
      window.open(url,url,'addressbar=0,directories=0,titlebar=0,toolbar=0,location=0,status=0,menubar=0,scrollbars=0,resizable=0');
    },
  },
}
</script>

<style>
.vs-pagination--buttons,
.vs-table--thead,
.vs-table--tbody,
.vs-button--icon {
  z-index: 1 !important;
}

#form-template {
  z-index: 1000 !important;
}
</style>
